export const getListBerthsByTenantEndpoint = (tenantId: string, warehouseId: string) =>
  `/berths/list_berths_by_tenant?tenant_id=${tenantId}&warehouse_id=${warehouseId}` as const
